import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// tailwind v4 styles
import "./styles/globals.css";

import { Amplify } from "aws-amplify";
import { censorStringByLength } from "./utils/censor";
import { App } from "./App";
import { buildAmplifyConfig } from "./lib/aws-amplify/config";

Amplify.configure(buildAmplifyConfig());

// localでSentryを使う場合は、配列に"local"を追加する
if (
  ["production", "staging", "develop"].includes(
    import.meta.env.VITE_SENTRY_ENVIRONMENT ?? ""
  )
) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event) {
      if (event.extra) {
        for (const prop in event.extra) {
          if (prop.includes("id")) {
            event.extra[prop] = censorStringByLength(
              event.extra[prop] as string
            );
          }
        }
      }
      return event;
    },
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
